import React from 'react';
import { useAuth } from 'src/contexts/auth';
import logoImg from 'src/assets/logo_branca.png'


interface AppTopbarProps {
    onToggleMenu: (event: any) => void;
}

const AppTopbar: React.FC<AppTopbarProps> = ({ onToggleMenu }) => {
    const { signOut } = useAuth();

    return (
        <div className="layout-topbar">
            <button className="p-link layout-menu-button" onClick={onToggleMenu}>
                <span className="pi pi-bars" />
            </button>
            <div className="layout-topbar-logo">
                <img src={logoImg} alt="InforFrota" style={{ width: "5em", height: 'auto' }} />
            </div>
            <div className="layout-topbar-icons">
                <button
                    onClick={signOut}
                    className="p-link"
                >
                    <i className="pi pi-fw pi-sign-out" />
                </button>
            </div>
        </div>
    );
}

export default AppTopbar;